export interface NavigationItem {
  readonly adminOnly?: boolean;
  readonly label: string;
  readonly shortLabel: string;
  readonly to: string;
}

export const navigationItems: readonly NavigationItem[] = [
  { label: "Positions", shortLabel: "Positions", to: "/positions" },
  { label: "Trade Activities", shortLabel: "Trades", to: "/trades" },
  { label: "Bots", shortLabel: "Bots", to: "/bots" },
  { label: "Backtests", shortLabel: "Tests", to: "/backtests" },
  { label: "Tickers", shortLabel: "Tickers", to: "/tickers" },
  { label: "AI Analysis", shortLabel: "AI Analysis", to: "/ai-analysis" },
  { label: "History", shortLabel: "History", to: "/history" },
  { label: "Settings", shortLabel: "Settings", to: "/settings" },
  { adminOnly: true, label: "Admin", shortLabel: "Admin", to: "/admin" },
];
